export default __webpack_public_path__ + "static/SR France - Safety Data Sheet - Caramel Color (Liquid)-ef29592681aa20cde3a10ace449e218d.pdf";